import { configureStore } from '@reduxjs/toolkit'
import setStateFun from './reducers/Reducer'

export const store = configureStore({
  reducer: setStateFun,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }),
})